
import { Entity } from "../helpers/Entity"

export type ExternalShippingMethodAttributes = {
    title: string,
    integrationKey: string,
    secondaryExternalId: string,
}

export type ExternalShippingMethodDto = {
    id: string
    type: string
    attributes: ExternalShippingMethodAttributes
}

export default class ExternalShippingMethod implements Entity {
    private dto: ExternalShippingMethodDto

    constructor(dto: ExternalShippingMethodDto) {
        this.dto = dto
    }

    isLoaded() {
        return this.dto.id != "" && this.dto.type == "external-shipping-method"
    }

    getId() {
        return this.dto.id
    }

    getTitle(): string {
        return this.dto.attributes.title
    }

    getIntegrationKey(): string {
        return this.dto.attributes.integrationKey
    }

    getSecondaryExternalId(): string {
        return this.dto.attributes.secondaryExternalId
    }
}


// WEBPACK FOOTER //
// ./src/state/fee/ExternalShippingMethod.ts